module.exports = "<div class=\"container\">\r\n    <div class=\"label\">{{ label }}</div>\r\n    <div class=\"data\">{{ data }}</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/verify/shared/component/label-data/label-data.component.html
// module id = ./src/app/verify/shared/component/label-data/label-data.component.html
// module chunks = main